import { Box, Typography } from '@mui/material'
import React from 'react'

type CardProps = {
  icon: React.ReactNode
  title: React.ReactNode
  children: React.ReactNode
}

export const InfoCard = ({ children, icon, title }: CardProps) => (
  <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 4, px: 3, py: 2 }}>
    <Box sx={{ alignItems: 'center', display: 'flex', fontSize: 16, gap: 1, pb: 2 }}>
      {icon}
      <Typography>{title}</Typography>
    </Box>
    {children}
  </Box>
)
